import { ActionHandler, ActionHandlerParams } from "..";
import { saveAnswers } from "./saveAnswers";
import { trackLead } from "src/utils/services/ConversionTracker";
import { trackGotEmail } from "src/utils/api/tracker";
import { flushCRMQueue } from "src/utils/brazeUploader";
import {
  isGDPRCountry,
  requiresDoubleOptInForEmail,
} from "src/utils/userSegment/features";
import { getAndMaybeSavePendingDoubleOptInStatus } from "src/utils/gdpr";
import { firePixelEvent } from "src/utils/pixels/handler";
import { saveMhmdaConsent } from "./saveMhmdaConsent";
import { trackBridgeEligibilityIfDetermined } from "src/utils/medicareEligibility";

type Params = {
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompleteMainSurvey: ActionHandler = async (
  actionParams: {
    params: Params;
  } & ActionHandlerParams
): Promise<void> => {
  const surveyAnswers = await saveAnswers(actionParams);

  trackBridgeEligibilityIfDetermined();

  if (
    surveyAnswers.gdprConsent &&
    (isGDPRCountry() || requiresDoubleOptInForEmail())
  ) {
    await getAndMaybeSavePendingDoubleOptInStatus();
  }

  await saveMhmdaConsent();

  await flushCRMQueue();

  const email = surveyAnswers.email || "";
  trackLead(email);
  if (email) {
    trackGotEmail(email);
  }

  firePixelEvent("finishMainSurvey", {});
};
